import { Page } from 'components/page/page.component'
import style from './roomReservations.module.css'
import { View } from 'components/view/view.component';
import { Filters } from 'components/filters/filters.component';
import { FilterType } from 'model/filter.model';
import { TextInput } from 'components/textInput/textInput.component';
import InputAdornment from '@mui/material/InputAdornment';
import { Icon } from 'components/icon/icon.component';
import { Button } from 'components/button/button.component';
import { Skeleton } from 'components/skeleton';
import { Table, TableBody, TableCell, TableHead, TableRow } from 'components/table/table.component';
import { Text } from 'components/text/text.component';
import { getOneMonthBefore, toDateHourMinuteString } from 'utils/date.util';
import { useDeleteRoomReservationApi, useGetRoomReservationsApi } from 'api/roomReservation.api';
import { useEffect, useState } from 'react';
import { FEATURE } from 'data/features.data';

type RoomReservationsPageProps = {
    companyId: string
}

export function RoomReservationsPage({companyId}: RoomReservationsPageProps){
    const [search, setSearch] = useState<string>('')
    const {data: roomReservationsData, get: getRoomreservationsApi} = useGetRoomReservationsApi()
    const roomReservations = roomReservationsData?.filter(rr => (!search || rr.room.name.includes(search))) || []
    const [filter, setFilter] = useState<FilterType | undefined>()
    const {delete: deleteRoomReservationApi} = useDeleteRoomReservationApi();

    useEffect(()=>{
        getRoomReservations()
    // eslint-disable-next-line
    }, [filter])
    
    function handleSearchChange(text: string){
        setSearch(text)
    }

    function getRoomReservations(){
        if(!filter) return
        const {buildings, areas, rooms, startDate, endDate} = filter;
        if(!rooms || rooms.length <= 0 || !startDate || !endDate) return
        getRoomreservationsApi({
            companyUsername: companyId,
            buildingIds: (buildings && buildings?.length > 0) ? buildings.map(b => b.id) : undefined,
            areaIds: (areas && areas?.length > 0) ? areas.map(a => a.id) : undefined,
            roomIds: rooms.map(r => r.id),
            startDate: startDate,
            endDate: endDate
        })
    }

    function handleFiltersChange(filter: FilterType){
        setFilter(filter)
    }

    function handleDeleteRoomReservation(id: string){
        if(!window.confirm('Deseja realmente excluir esta reserva de sala?')) return
        deleteRoomReservationApi(id).then(() => {
            alert('Reserva de sala excluída com sucesso!');
            // Optionally, refresh the list or show a success message
            getRoomReservations()
        }).catch(error => {
            console.error('Erro ao excluir reserva de sala:', error);
            alert('Erro ao excluir reserva de sala. Tente novamente mais tarde.');
        });
    }

    return (
        <Page title='Reserva de Salas' menu header >
            <View className={style.Content}>
                <View className={style.FiltersContainer}>
                    <Filters 
                        showBuildings 
                        onlyOneBuilding 
                        showAreas 
                        onlyOneArea 
                        showRooms 
                        onlyOneRoom
                        showStartDate 
                        showEndDate
                        initialStartDate={getOneMonthBefore(new Date())}
                        initialEndDate={new Date()}
                        dateType='datetime'
                        companyId={companyId} 
                        onChange={handleFiltersChange} 
                    />
                </View>
            
                <View className={style.ContentHeader}>
                    <TextInput 
                        fullWidth 
                        InputProps={{
                            startAdornment: <InputAdornment position="start"><Icon>search</Icon></InputAdornment>,
                        }}
                        // value={search}
                        onChange={(e)=> handleSearchChange(e.target.value)}
                        size='small'
                    />
                    <a href={`${companyId ? `/${companyId}` : ''}/cadastro/reserva-sala`}>
                        <Button className={style.AddButton} variant='contained' size='medium' ><Icon primaryContrast >add_circle</Icon>Novo Sala</Button>
                    </a>
                </View>

                {false
                ?  <Skeleton className={style.Skeleton} />
                : <View className={style.TableContainer}>
                    <View className={style.TableContent}>
                        <Table >
                            <TableHead>
                                <TableRow>
                                    <TableCell><Text type='h4'>Sala</Text></TableCell>
                                    <TableCell><Text type='h4'>Início</Text></TableCell>
                                    <TableCell><Text type='h4'>Fim</Text></TableCell>
                                    <TableCell><Text type='h4'>Reservado por</Text></TableCell>
                                    <TableCell><Text type='h4'>Participantes</Text></TableCell>
                                    <TableCell><Text type='h4'>Ações</Text></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                !filter?.rooms || filter.rooms.length <= 0
                                ?<TableRow className={style.Content}>
                                    <TableCell colSpan={5}>
                                        <Text type='sm'>Selecione uma sala</Text>
                                    </TableCell>
                                </TableRow>
                                // : !area ? 
                                // <TableRow className={style.Content}>
                                //     <TableCell colSpan={5}>
                                //         <Text type='sm'>Selecione um andar</Text>
                                //     </TableCell>
                                // </TableRow>
                                : 
                                (!roomReservations || roomReservations?.length <= 0)
                                ? <TableRow className={style.Content}>
                                    <TableCell colSpan={5}>
                                        <Text type='sm'>{`Nenhuma reserva de sala encontrada`}</Text>
                                    </TableCell>
                                </TableRow>
                                : roomReservations.map(roomReservation => <TableRow key={roomReservation.id}>
                                    <TableCell><Text type='sm'>{roomReservation.room.name}</Text></TableCell>
                                    <TableCell><Text type='sm'>{toDateHourMinuteString(roomReservation.startAt)}</Text></TableCell>
                                    <TableCell><Text type='sm'>{toDateHourMinuteString(roomReservation.endAt)}</Text></TableCell>
                                    <TableCell><Text type='sm'>{roomReservation.reservedBy}</Text></TableCell>
                                    <TableCell><Text type='sm'>{roomReservation.participants}</Text></TableCell>
                                    <TableCell>
                                        <View className={style.Actions}>
                                            <View title='Editar sala'>
                                            <a href={`/${companyId}/cadastro/reserva-sala/${roomReservation.id}`}>
                                                <Icon >edit_square</Icon>
                                            </a>
                                            </View>
                                            <View title='Deletar lançamento' features={[FEATURE.ROOM_RESERVATION_DELETE.id]} onClick={() => handleDeleteRoomReservation(roomReservation.id)}>
                                                <Icon >delete</Icon>
                                            </View>
                                        </View>
                                    </TableCell>
                                </TableRow>)
                                }
                            </TableBody>
                        </Table>
                    </View>
                </View>
                }
            </View>
        </Page>
    );
}